import { AlertDialog as AlertDialogRoot } from './AlertDialog';
import { AlertDialogContent } from './components/AlertDialogContent';
import { AlertDialogFooter } from './components/AlertDialogFooter';
import { AlertDialogHeader } from './components/AlertDialogHeader';
import { AlertDialogOverlay } from './components/AlertDialogOverlay';
import { AlertDialogPortal } from './components/AlertDialogPortal';
import { AlertDialogTitle } from './components/AlertDialogTitle';

export const AlertDialog = Object.assign(AlertDialogRoot, {
  Content: AlertDialogContent,
  Footer: AlertDialogFooter,
  Header: AlertDialogHeader,
  Overlay: AlertDialogOverlay,
  Portal: AlertDialogPortal,
  Title: AlertDialogTitle,
});

export {
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
};
